import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';
import Icon from '../Icon/Icon';
import MoreOrLessButton from '../MoreOrLessButton/MoreOrLessButton';
import phones from '../../utils/Phones';

const CompactPhoneNumbers = ({
  phone_numbers = [],
  max_numbers_collapsed = 3,
}) => {
  if (!phone_numbers.length) {
    return null;
  }

  const rootClasses = cn('relative mb-5 leading-5');

  const phoneNumbers = phones
    .sortPhoneNumbers(phone_numbers, [
      'mobile',
      'home',
      'work',
      'fax',
      'unknown',
    ])
    .filter((number) => Boolean(number.phone_number));

  const PhoneNumbersList = ({ showMore }) => (
    <>
      {phoneNumbers.map((phoneNumber, index) => {
        const {
          extension = '',
          phone_type = '',
          phone_number = '',
          is_primary = false,
        } = phoneNumber;

        if (
          (!showMore && index + 1 > max_numbers_collapsed) ||
          !phone_number
        ) {
          return null;
        }

        return (
          <div
            className="pl-8 mt-1 leading-5 text-sm text-text-blue normal-case font-regular-font"
            key={`phone-${phone_number}`}
          >
            {phone_type && (
              <span
                className="capitalize"
                data-test-element={`phone-numbers_type_${index}`}
              >
                {phone_type}:{' '}
              </span>
            )}

            <a
              href={phones.getTelLink(phoneNumber)}
              target="_blank"
              tabIndex={0}
              rel="noopener noreferrer"
              data-test-element={`phone-numbers_link_${index}`}
            >
              <span data-test-element={`phone-numbers_number_${index}`}>
                {`${phones.formatPhoneNumber(phone_number)}${
                  extension ? ` ${extension}` : ''
                }`}
              </span>
            </a>

            {is_primary && (
              <span
                className="italic"
                data-test-element={`phone-numbers_primary_${index}`}
              >
                {' '}
                Primary
              </span>
            )}
          </div>
        );
      })}
    </>
  );

  PhoneNumbersList.propTypes = {
    showMore: PropTypes.bool.isRequired,
  };

  return (
    <div className={rootClasses}>
      <div className="absolute top-0 left-0">
        <Icon size={20} icon="Phone" color="action-blue" />
      </div>
      {(phoneNumbers.length > max_numbers_collapsed) ? <MoreOrLessButton
        moreText="See more"
        lessText="See less"
        className="mt-1 py-2"
        omitDefaultStyles
      >
        <PhoneNumbersList />
      </MoreOrLessButton> :
      <PhoneNumbersList />}
    </div>
  );
};

CompactPhoneNumbers.propTypes = {
  phone_numbers: PropTypes.arrayOf(
    PropTypes.shape({
      phone_type: PropTypes.string,
      phone_number: PropTypes.string,
      country_code: PropTypes.string,
      is_primary: PropTypes.bool,
      extension: PropTypes.string,
    })
  ),
  max_numbers_collapsed: PropTypes.number,
};

export default CompactPhoneNumbers;
